import { render, staticRenderFns } from "./InnerContent.vue?vue&type=template&id=40ddfc86"
import script from "./InnerContent.vue?vue&type=script&lang=js"
export * from "./InnerContent.vue?vue&type=script&lang=js"
import style0 from "./InnerContent.vue?vue&type=style&index=0&id=40ddfc86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports